import moment from 'moment'

/**
 * Function for converting JSON Date into full date.
 *
 * @param date JSON date
 * @returns Correctly formatted date. Ex: 25/12/2021 - 3:22 PM
 */

const getFullDate = (date: string | number) => {
	return moment(date).format('DD/MM/YYYY - h:mm A')
}

export default getFullDate
